import api from '@/libs/axiosInstance';
import type { ApiResponse, ListTeamMembersResponse } from '@fluenceur/types';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

export const teamMembersQueryOptions = (page = 1) => ({
  queryKey: ['team', 'members', { page, perPage: 20 }],
  queryFn: async ({ signal }: { signal: AbortSignal }): Promise<ListTeamMembersResponse> => {
    const response = await api.get<ApiResponse<ListTeamMembersResponse>>(
      '/dashboard/team/members',
      {
        params: { page, perPage: 20 },
        signal,
      }
    );
    if (response.data.success && response.data.data) return response.data.data;
    throw new Error(response.data.message || 'Failed to fetch team members');
  },
});

export const useTeamMembersPageQuery = (page: number) =>
  useQuery({ ...teamMembersQueryOptions(page), placeholderData: keepPreviousData });

export const useTeamMembersQuery = () =>
  useQuery({ ...teamMembersQueryOptions(), select: (result) => result.data });
